
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/balance/migration-guide",
      function () {
        return require("private-next-pages/docs/balance/migration-guide.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/balance/migration-guide"])
      });
    }
  